module.exports = __webpack_public_path__ + "static/slider-center-cb0741d010fdf6056302988cbe8d365f.gif";